<template>
	<div class="map_box" style="width: 1200px; height: 480px">
		<div class="container">
			<div class="tips">去北京数科网维技术有限责任公司怎么走？上图的标记是北京数科网维技术有限责任公司在北京的具体位置标注。</div>
			<div class="seach_box" @click="gsAddress">
				<div class="title" style="font-size: 20px">北京数科网维技术有限责任公司</div>
				<div class="stitle">
					<span></span>
					<p>北京市海淀区车道沟1号青东商务区A座东7层</p>
				</div>
			</div>
			<!--
        amap-manager： 地图管理对象
        vid：地图容器节点的ID
        zooms： 地图显示的缩放级别范围，在PC上，默认范围[3,18]，取值范围[3-18]；在移动设备上，默认范围[3-19]，取值范围[3-19]
        center： 地图中心点坐标值
        plugin：地图使用的插件
        events： 事件
      -->
			<!-- <el-amap ref="map" vid="amapDemo" :center="center" :zoom="zoom" :plugin="plugin" :events="events" class="amap-demo">
				<el-amap-marker v-for="(marker, i) in markers" :key="i" :position="marker.position" :icon="marker.icon"></el-amap-marker>
			</el-amap> -->
			<img src="@comm/images/document-conversion/map_bj.png" style="width: 100%;"/>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			zoom: 20,
			center: [116.304255, 39.945454],
			markers: [
				{
					icon: require("@comm/images/document-conversion/marker_icon.png"),
					position: [116.304255, 39.945454],
					events: {
						click: () => {
							alert("click marker");
						},
						dragend: (e) => {
							this.markers[0].position = [e.lnglat.lng, e.lnglat.lat];
						}
					},
					visible: true,
					draggable: false,
					template: "<span>1</span>"
				}
			],
			events: {
				init: (o) => {
					o.getCity((result) => {});
				},
				moveend: () => {},
				zoomchange: () => {},
				click: (e) => {
					let { lng, lat } = e.lnglat;
					self.lng = lng;
					self.lat = lat;
					let points = [self.lng, self.lat];
					this.getAddress(points);
					let marker = {
						position: [self.lng, self.lat]
					};
					//  if (!this.markers.length) return;
					//     this.markers.splice(this.markers.length - 1, 1);

					this.markers.push(marker);
				}
			},

			getAddress(points) {
				let geocoder = new AMap.Geocoder({ radius: 1000, extensions: "all" });
				geocoder.getAddress(points, (status, result) => {
					if (status === "complete" && result.regeocode) {
						this.address = result.regeocode.formattedAddress;
					}
				});
			},
			plugin: [],
			// plugin: ["AMap.ToolBar"],
			texts: [
				{
					position: [116.304255, 39.945454],
					text: "hello world",
					offset: [0, 0],
					events: {
						click: () => {
							alert("click text");
						}
					}
				}
			]
		};
	},
	methods: {
		gsAddress() {
			this.zoom = 20;
			this.markers[0].position = [116.304255, 39.945454];
			this.center = [116.304255, 39.945454];
		},

		getMap() {
			// gaode map instance
			alert("click text");
		}
	}
};
</script>

<style lang="scss">
.map_box {
	width: 1200px;
	height: 480px;
	margin: 0 auto;
}
.container,
.container-lg,
.container-md,
.container-sm,
.container-xl {
	max-width: 1200px !important;
	padding: 0 !important;
}
.amap-icon img {
	width: 76px !important;
	top: -48px !important;
	left: -36px !important;
}
.container {
	width: 100%;
	height: 100%;
	position: relative;
	.tips {
		height: 40px;
		background: rgba(0, 0, 0, 0.5);
		width: 100%;
		text-align: center;
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		line-height: 40px;
		position: absolute;
		bottom: 0;
		left: 0;
		z-index: 99;
	}
}
.seach_box {
	cursor: pointer;
	position: absolute;
	top: 24px;
	left: 24px;
	z-index: 5;
	width: 312px;
	height: 155px;
	background: #ffffff;
	padding: 20px 16px;
	box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.25);
}
.seach_box .title {
	font-size: 20px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #36425a;
	line-height: 28px;
	padding-bottom: 20px;
	border-bottom: 1px solid #d5d5d5;
	margin-bottom: 20px;
	white-space: nowrap;
	overflow: auto;
}
.seach_box .stitle {
	display: flex;
	align-items: flex-start;
	span {
		display: inline-block;
		width: 24px;
		height: 24px;
		background: url("../../../images/document-conversion/address_icon.png") 0 0 no-repeat;
		background-size: 100%;
	}
	p {
		flex: 1;
		font-size: 18px;
		font-weight: 400;
		color: #383e45;
		line-height: 22px;
		padding-left: 8px;
	}
}
.tip-box {
	width: 100%;
	max-height: 260px;
	position: absolute;
	top: 30px;
	overflow-y: auto;
	background-color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/comm/components/document-conversion/map/index.vue